import { render, staticRenderFns } from "./BudgetBar.vue?vue&type=template&id=21deefa6&scoped=true&"
import script from "./BudgetBar.vue?vue&type=script&lang=js&"
export * from "./BudgetBar.vue?vue&type=script&lang=js&"
import style0 from "./BudgetBar.vue?vue&type=style&index=0&id=21deefa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21deefa6",
  null
  
)

export default component.exports